import SpecialMarketEvent, { SpecialMarketEventIncomplete } from '@core/models/specials/SpecialMarketEvent';
import Plain from '@core/utils/types/Plain';

export interface ISpecialMarket {
    id: number;
    isAvailableForBetting: () => boolean;
    isCurrentlyOffered: () => boolean;
    specialMarketEvents: (SpecialMarketEvent | SpecialMarketEventIncomplete)[];
}

class SpecialMarketBase implements ISpecialMarket {
    id: number;
    specialMarketEvents: (SpecialMarketEvent | SpecialMarketEventIncomplete)[];

    constructor(data: Plain<SpecialMarketIncomplete>) {
        this.specialMarketEvents = data.specialMarketEvents;
    }

    public isCurrentlyOffered() {
        return this.specialMarketEvents.some((marketEvent) => marketEvent.isCurrentlyOffered());
    }

    public isAvailableForBetting() {
        return this.specialMarketEvents.some((marketEvent) => marketEvent.isAvailableForBetting());
    }
}

export class SpecialMarketIncomplete extends SpecialMarketBase {
    // this is actually an oddType but renamed to marketEvent for clarity
    specialMarketEvents: SpecialMarketEventIncomplete[];

    constructor(data: Plain<SpecialMarketIncomplete>) {
        super(data);
        Object.assign(this, data);
    }
}
export default class SpecialMarket extends SpecialMarketBase {
    name: string;
    footer: string;
    fieldDefinitions: string[];
    enteringCodes: number[];
    specialMarketEvents: SpecialMarketEvent[];

    constructor(data: Plain<SpecialMarket>) {
        super(data);
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/specials/SpecialMarket.ts